
<body >


  <div role="main" class="main">

    <section class="page-header">
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <ul class="breadcrumb">
              <li><a href="/">Anasayfa</a></li>
              <li class="active">Bize Ulaşın</li>
            </ul>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <h1>Bize Ulaşın</h1>
          </div>
        </div>
      </div>
    </section>

    <!-- Google Maps - Go to the bottom of the page to change settings and map location. -->
    <!--<div id="googlemaps" class="google-map"></div>-->

     <iframe width="100%" height="600" src="https://maps.google.com/maps?q=intes%20technology&t=&z=13&ie=UTF8&iwloc=&output=embed" frameborder="0" scrolling="no" marginheight="0" marginwidth="0"><a href="https://www.maps.ie/map-my-route/">Google maps üzerinden yol tarifi al.</a></iframe><br />

    <div class="container">

      <div class="row">
        <div class="col-md-6">

          <div class="alert alert-success hidden" id="contactSuccess">
            <strong>Başarılı!</strong> Mesajınız bize gönderildi.
          </div>

          <div class="alert alert-danger hidden" id="contactError">
            <strong>Hata!</strong> Mesajınız gönderirken bir hata oluştu.
          </div>

          <h2 class="mb-sm mt-sm"><strong>Bize</strong> Ulaşın</h2>
            <div class="row">
              <div class="form-group">
                <div class="col-md-6">
                  <label>Ad Soyad *</label>
                  <input type="text" [(ngModel)]="contact.name" data-msg-required="Lütfen adınızı giriniz." maxlength="100" class="form-control" name="name" id="name" required>
                </div>
                <div class="col-md-6">
                  <label>Email *</label>
                  <input type="email" [(ngModel)]="contact.email" data-msg-required="Lütfen Email adresinizi giriniz." data-msg-email="Lütfen geçerli bir Email adresi giriniz." maxlength="100" class="form-control" name="email" id="email" required>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="form-group">
                <div class="col-md-12">
                  <label>Konu *</label>
                  <input type="text" value="" [(ngModel)]="contact.subject" data-msg-required="Lütfen konu giriniz." maxlength="100" class="form-control" name="subject" id="subject" required>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="form-group">
                <div class="col-md-12">
                  <label>Mesaj *</label>
                  <textarea maxlength="5000" [(ngModel)]="contact.message" data-msg-required="Lütfen mesajınızı giriniz." rows="10" class="form-control" name="message" id="message" required></textarea>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <input type="button" (click)="sendContact()" value="Gönder" class="btn btn-primary btn-lg mb-xlg" id="send" data-loading-text="Gönderiliyor...">

              </div>
            </div>
        </div>
        <div class="col-md-6">
          <hr>

          <h4 class="heading-primary"><strong>Ofislerimiz</strong></h4>
          <ul class="list list-icons list-icons-style-3 mt-xlg">
            <li><i class="fa fa-map-marker"></i> <strong>Merkez:</strong> Cevizli Mah. Mustafa Kemal Cad. Hukukçular Towers A Blok Kat:5 No:66/39 Kartal, İstanbul / Türkiye</li>
            <li><i class="fa fa-map-marker"></i> <strong>GOSB Teknopark:</strong> Gebze Osb Mah. Kemal Nehrozoğlu Cad. GOSB Teknopark HighTech Binası A Blok Kat:2 No:10 Gebze, Kocaeli / Türkiye</li>
            <li><i class="fa fa-phone"></i> <strong>Telefon:</strong> (+90) 216 709 38 42</li>
            <li><i class="fa fa-envelope"></i> <strong>Email:</strong> <a href="mailto:info@intestech.com.tr">info@intestech.com.tr</a></li>
          </ul>

          <hr>

          <h4 class="heading-primary"><strong>Çalışma Saatlerimiz</strong></h4>
          <ul class="list list-icons list-dark mt-xlg">
            <li><i class="fa fa-clock-o"></i> Pazartesi - Cuma - 09:00 - 18:00</li>
            <li><i class="fa fa-clock-o"></i> Cumartesi- Pazar - Kapalı</li>
          </ul>

          <hr>

        </div>

      </div>

    </div>

  </div>

  <section class="call-to-action call-to-action-default with-button-arrow call-to-action-in-footer">
    <div class="container">
      <div class="row">
        <div class="col-md-12">

        </div>
      </div>
    </div>
  </section>

  <script src="http://maps.google.com/maps/api/js"></script>
  <script>

    /*
    Map Settings

      Find the Latitude and Longitude of your address:
        - http://universimmedia.pagesperso-orange.fr/geo/loc.htm
        - http://www.findlatitudeandlongitude.com/find-address-from-latitude-and-longitude/

    */

    // Map Markers
    var mapMarkers = [{
      address: "Cevizli, Mustafa Kemal Paşa Caddesi, Kartal, İstanbul",
      html: "<strong>Intes Technology Ofis</strong><br>İstanbul, Türkiye",
      icon: {
        image: "img/pin.png",
        iconsize: [26, 46],
        iconanchor: [12, 46]
      },
      popup: true
    }];

    // Map Initial Location
    var initLatitude = 40.9111589;
    var initLongitude = 29.1786589;

    // Map Extended Settings
    var mapSettings = {
      controls: {
        draggable: (($.browser.mobile) ? false : true),
        panControl: true,
        zoomControl: true,
        mapTypeControl: true,
        scaleControl: true,
        streetViewControl: true,
        overviewMapControl: true
      },
      scrollwheel: false,
      markers: mapMarkers,
      latitude: initLatitude,
      longitude: initLongitude,
      zoom: 16
    };

    var map = $("#googlemaps").gMap(mapSettings);

    // Map Center At
    var mapCenterAt = function(options, e) {
      e.preventDefault();
      $("#googlemaps").gMap("centerAt", options);
    }

  </script>


